// TODO: 特别声明：每一个开发的控件必须要加一个change回调事件！
const componentNameMap = {
    // 应用层
    themeColor: "themeColor",
    themeIcon: "themeIcon"

};

// 组件相对路径映射图
const pathMap = {
    innerApp: {
        themeColor: "./themeColor.vue",
        themeIcon: "./themeIcon.vue"
    }
};

// 得到组件注册对象
function registerComponents (map = pathMap) {
    const loop = (map, obj) => {
        return Object.entries(map).reduce((obj, arr) => {
            if (Object.prototype.toString.call(arr[1]) === "[object Object]") {
                return loop(arr[1], obj);
            } else {
                return Object.assign(obj, {
                    [arr[0]]: () => import(`${arr[1]}`)
                });
            }
        }, obj);
    };
    return loop(map, {});
};

export default {
    componentNameMap,
    pathMap,
    registerComponents
};



// WEBPACK FOOTER //
// ./src/components/controls/index.js